import React from 'react';
import { PageLayout } from 'client/ui/layout/PageLayout';
import { LoaderSpinProps, LoaderSpin } from './LoaderSpin';

export interface LoadingPageProps extends LoaderSpinProps {}

export function LoadingPage(props: LoadingPageProps) {
  const { ...otherProps } = props;

  return (
    <PageLayout hasMenu hasScrollable>
      <LoaderSpin {...otherProps} transparent />
    </PageLayout>
  );
}
